import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { isShowingClearQueuePopup } from "../../reducers/clearQueue";
import { clearQueue, executeClearQueuePostOperation, setClearQueuePopupShowing } from "../../actions/clearQueueActions";
import BlockingScreenLayer from "../common/containers/BlockingScreenLayer";
import ConfirmPopup from "./ConfirmPopup";
import LoadingBar from "../loading/LoadingBar";
import { FULLY_BLOCKING_POPUP_ZINDEX as zIndex } from "../../utils/constants/otherConstants";
import { setAlwaysClearQueue } from "../../actions/userSettingsActions";
import { useSnackbar } from "notistack";
import { clearingQueueRunning } from "../../reducers/disablingProcesses";

const ClearQueuePopup = () => {
    const showConfirmPopup = useSelector(isShowingClearQueuePopup);
    const showLoadingBar = useSelector(clearingQueueRunning);
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    

    // #region OnClick handlers

    const onClickCancel = () => dispatch(setClearQueuePopupShowing(false));
    const onClickNoClear = (notShowAgain) => { 
        if(notShowAgain)
        {
            dispatch(setAlwaysClearQueue(false));
            enqueueSnackbar('You can change this behavior in the user settings', { variant: 'info' });
        }

        onClickCancel();
        dispatch(executeClearQueuePostOperation());
    }
    const onClickClear = (notShowAgain) => { 
        if(notShowAgain)
        {
            dispatch(setAlwaysClearQueue(true));
            enqueueSnackbar('You can change this behavior in the user settings', { variant: 'info' });
        }

        onClickCancel();
        dispatch(clearQueue()); 
    }

    // #endregion OnClick handlers

    const buttons = [
        {
            onClick: onClickCancel,
            text: "Cancel"
        },
        {
            onClick: onClickNoClear,
            text: "Don't clear"
        },
        {
            onClick: onClickClear,
            text: "Clear"
        }
    ]

    return (
        <>
        {
            (showConfirmPopup || showLoadingBar) &&
            <BlockingScreenLayer zIndex={zIndex}>
                <div className="full-width full-height d-flex flex-row jc-center ai-center">
                    {
                        showConfirmPopup &&
                        <ConfirmPopup
                            title="Do you want to automatically clear your current queue before?"
                            message="If your queue is currently empty, click on 'Don't clear'."
                            notShowAgainCheckbox={true}
                            buttons={buttons}
                        />
                    }
                    {
                        showLoadingBar &&
                        <LoadingBar customLoadingText="Clearing queue..." />
                    }
                </div>
            </BlockingScreenLayer>
        }
        </>
    )
}

export default React.memo(ClearQueuePopup);